export default __webpack_public_path__ + "static/media/logo.e78256fc.png";